export default __webpack_public_path__ + "static/media/truck.5c253697.svg";